export default {
  currentQuestion: 'isVet',
  currentError: undefined,
  slideDirection: 'next',
  loading: false,
  isVet: undefined,
  benefits: undefined,
  reasonFor: undefined,
  schedule: undefined,
  visit: [],
  driveTime: undefined,
  tried: undefined,
  waitTime: undefined,
  qualify: undefined
}
